import $ from 'jquery'

class FilterDropdowns {
  constructor(selector = '.filterdropdown') {
    this.items = $(selector)

    this.init()

    return this.items
  }

  init() {
    this.items.each((index, item) => new FilterDropdown(item))
  }
}

class FilterDropdown {
  constructor(item) {
    this.el = $(item)
    this.openTrigger = $('.filterdropdown__button', item)
    this.closeTrigger = $('.filterdropdown__header-closebutton', item)
    this.saveTrigger = $('.filterdropdown__save', item)
    this.content = $('.filterdropdown__content', item)
    this.checkbox = $('input', item)
    this.resetTrigger = $('.filterdropdown__reset', item)
    this.filterCount = $('.filterdropdown__count', this.el)
    this.successMessage = $('.filterdropdown__footer.success', item)
    this.errorMessage = $('.filterdropdown__footer.error', item)
    this.grayOverlay = $('.gray-overlay', item)
    // states
    this.isOpen = false
    this.isFilterDropdown = this.el.hasClass('filterdropdown--filter')
    this.isMobile = this.el.hasClass('filterdropdown--mobile')
    this.activeOutsideWindowListener = null

    this.init()
  }

  init() {
    this.listen()
    this.setCount()
  }

  listen() {
    this.openTrigger.on('click', () => {
      if (this.isOpen === false) {
        this.successMessage.removeClass('show')
        this.errorMessage.removeClass('show')
        this.grayOverlay.removeClass('show')
        this.open()
      } else {
        this.close()
      }
    })
    this.closeTrigger.on('click', () => {
      // this.showErrorMessage()
      this.close()
    })
    this.saveTrigger.on('click', event => {
      event.preventDefault()
      this.close()
    })

    this.resetTrigger.on('click', event => {
      event.preventDefault()
      this.showSuccessMessage()
    })

    this.checkbox.on('input', event => {
      this.el.trigger('filter-changed', [
        {
          name: event.target.name,
          value: event.target.value,
        },
      ])
    })

    this.el.on('update-filter', (event, data) => {
      this.onUpdateFilter(data)
    })
  }

  listenOutsideClick() {
    this.activeOutsideWindowListener = this.generateOutsideClickCallback()
    $(window).on('click', this.activeOutsideWindowListener)
  }

  unlistenOutsideClick() {
    $(window).off('click', this.activeOutsideWindowListener)
    this.activeOutsideWindowListener = null
  }

  generateOutsideClickCallback() {
    return function(event) {
      const isOriginInside = !!$(event.target).closest(this.el).length
      if (isOriginInside) {
        return
      }
      this.close()
    }.bind(this)
  }

  open() {
    this.isOpen = true
    this.content.addClass('filterdropdown__content--active')
    this.openTrigger.addClass('filterdropdown__button--active')
    this.listenOutsideClick()
  }

  close() {
    this.isOpen = false
    this.content.removeClass('filterdropdown__content--active')
    this.openTrigger.removeClass('filterdropdown__button--active')
    this.unlistenOutsideClick()
  }

  setCount() {
    console.log(this.checkbox.filter(':checked'))
    const count = this.checkbox.filter(':checked').length
    this.filterCount.html(count ? '(' + count + ')' : '')
  }

  showSuccessMessage() {
    this.successMessage.removeClass('show')
    this.grayOverlay.removeClass('show')
    void this.successMessage.width() // this forcefully restarts the animation of the successmessage
    void this.grayOverlay.width() // this forcefully restarts the animation the gray overlay
    this.successMessage.addClass('show')
    this.grayOverlay.addClass('show')
  }

  showErrorMessage() {
    this.errorMessage.removeClass('show')
    this.grayOverlay.removeClass('show')
    void this.errorMessage.width() // this forcefully restarts the animation of the successmessage
    void this.grayOverlay.width() // this forcefully restarts the animation the gray overlay
    this.errorMessage.addClass('show')
    this.grayOverlay.addClass('show')
  }
}

export default FilterDropdowns
